var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header"},[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1eef53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget.vue
// module id = zKJh
// module chunks = 363